import { fetchPageById, fetchDescendantsWithSpecificContentType } from "../../UmbracoContentDeliveryApiUtils";
import featureStories, { feature } from "../feature/feature.stories";
import { ILoadedNewsLandingHeroData } from "./news-landing-hero-types";

function extractNecessaryPropertiesFromEachNewsItem(newsItems) {
    return newsItems.map((newsItem) => {
        return {
            id: newsItem.id,
            name: newsItem.properties.articleHeroHeading,
            summary: newsItem.properties.introText,
            media: newsItem.properties.articleHeroImage || newsItem.properties.shareImage,
            url: newsItem.route.path,
            author: newsItem.properties.author?.map(author => {
                return {
                    id: author.id,
                    name: author.name,
                }
            }),
            publicationDate: newsItem.properties.publicationDate != null ? new Date(newsItem.properties.publicationDate) : new Date(newsItem.createDate)
        }
    });
}

async function doItAll(pageId: string): Promise<ILoadedNewsLandingHeroData | void> {

    const thePageId = pageId;

    const newsLandingPage = await fetchPageById(thePageId);

    const newsLandingPageDescendants = await fetchDescendantsWithSpecificContentType(thePageId, 11, "newsPage");

    let featuredStories = [];
    let latestStories = [];

    if (newsLandingPage.properties.featuredStories !== null) {
        const featuredArticlesParentId = newsLandingPage.properties.featuredStories[0].id;
        const newsListingPageForFeaturedStories = await fetchDescendantsWithSpecificContentType(featuredArticlesParentId, 3, "newsPage");
        featuredStories = newsListingPageForFeaturedStories.items;
    }

    if (newsLandingPage.properties.overrideFeaturedStories !== null) {
        featuredStories = newsLandingPage.properties.overrideFeaturedStories;
    }

    const featuredStoriesIds = featuredStories.map(story => story.id);

    latestStories = newsLandingPageDescendants.items.filter(item => !featuredStoriesIds.includes(item.id));

    featuredStories = extractNecessaryPropertiesFromEachNewsItem(featuredStories);
    latestStories = extractNecessaryPropertiesFromEachNewsItem(latestStories.slice(0, 5));


    return { featuredStories, latestStories };
}

export { doItAll };